<template>
  <div v-if="results && results.length === 0" class="search-no-results-text">
    <div class="no-results">
      {{ $t('SEARCH.NO_RESULTS') }}
    </div>
    <div class="pgnnp-container">
      <Paganiniplus />
    </div>
  </div>
</template>

<script>
import Paganiniplus from '@/components/tsp/Paganiniplus'
export default {
  name: 'SearchNoResultsText',
  components: {
    Paganiniplus
  },
  directives: {},
  props: {
    results: {
      type: Array,
      default: undefined
    }
  },
  data() {
    return {}
  },
  computed: {
    getSearchedKeyword() { return this.$store.getters.getSearchedKeyword }
  },
  watch: {},
  created() {},
  mounted() {},
  updated() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
.no-results {
  margin-bottom: 36px;
  font-size: 24px;
  font-weight: 500;
  line-height: 1.63;
  color: $grey-9b;
}
@media only screen and (max-width: 368.98px) {
  .pgnnp-container {
    margin: 0 -24px;
  }
}
</style>
